"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  FormControl: true,
  FormControlContext: true,
  useFormControlContext: true
};
Object.defineProperty(exports, "FormControl", {
  enumerable: true,
  get: function () {
    return _FormControl.FormControl;
  }
});
Object.defineProperty(exports, "FormControlContext", {
  enumerable: true,
  get: function () {
    return _FormControlContext.FormControlContext;
  }
});
Object.defineProperty(exports, "useFormControlContext", {
  enumerable: true,
  get: function () {
    return _useFormControlContext.useFormControlContext;
  }
});
var _FormControl = require("./FormControl");
var _FormControlContext = require("./FormControlContext");
var _formControlClasses = require("./formControlClasses");
Object.keys(_formControlClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _formControlClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _formControlClasses[key];
    }
  });
});
var _useFormControlContext = require("./useFormControlContext");